import { render } from "./PortfolioPageItem.vue?vue&type=template&id=325659c0&scoped=true"
import script from "./PortfolioPageItem.vue?vue&type=script&lang=js"
export * from "./PortfolioPageItem.vue?vue&type=script&lang=js"

import "./PortfolioPageItem.vue?vue&type=style&index=0&id=325659c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325659c0"]])

export default __exports__